export function sparklesExplosion(k) {
    const particleCount = /Mobi|Android|iPhone/i.test(navigator.userAgent) ? 6 : 12;

    const spawnPos = k.mousePos();
    for (let i = 0; i < particleCount; i++) {
        const angle = (Math.PI * 2 * i) / 10 + Math.random() * 0.4;
        k.add([
            k.pos(spawnPos),
            k.circle(k.rand(2, 5)),
            k.color(k.rgb(255, k.rand(180, 255), k.rand(50, 150))),
            k.opacity(1),
            k.z(300), // Keep particles above even selected cards
            k.move(k.vec2(Math.cos(angle), Math.sin(angle)), k.rand(150, 300)),
            k.lifespan(0.4, { fade: 0.3 }),
        ]);
    }
}